import { useNavigate } from 'react-router'
import { GoChevronRight, GoChevronLeft } from 'react-icons/go'
import { IoPersonOutline, IoKeyOutline, IoHeartOutline } from 'react-icons/io5'

const Account: React.FC = () => {
  const navigate = useNavigate()
  return (
    <div className="flex w-full flex-col text-sm">
      <div className="flex h-[50px] items-center pl-[10px] text-xl font-semibold">
        <div className="flex items-center">
          <button
            type="button"
            className="hover-main mr-[10px] flex h-[30px] w-[30px] items-center justify-center rounded-full"
            onClick={() => {
              navigate('/settings')
            }}
          >
            <GoChevronLeft />
          </button>
          <h1>Your account</h1>
        </div>
      </div>
      <div className="text-sub pt-[15px] pb-[25px] pl-[25px]">
        See information about your account or learn about your account
        deactivation options
      </div>
      <button
        type="button"
        className={
          'hover-main flex h-[80px] w-full cursor-pointer items-center justify-between'
        }
        onClick={() => {
          navigate('../information')
        }}
      >
        <div className="flex items-center justify-between">
          <IoPersonOutline className="text-sub mr-[30px] ml-[30px] text-lg" />
          <div className="flex w-auto flex-col text-wrap">
            <h1 className="flex items-center">Account information</h1>
            <h1 className="text-sub flex items-center">
              See your account information like your email etc.
            </h1>
          </div>
        </div>
        <div className="text-sub flex h-full w-auto items-center pr-[15px] text-2xl">
          <GoChevronRight />
        </div>
      </button>
      <button
        type="button"
        className={
          'hover-main flex h-[80px] w-full cursor-pointer items-center justify-between'
        }
        onClick={() => {
          navigate('../password')
        }}
      >
        <div className="flex items-center justify-between">
          <IoKeyOutline className="text-sub mr-[30px] ml-[30px] text-lg" />
          <div className="flex w-auto flex-col text-wrap">
            <h1 className="flex items-center">Change password</h1>
            <h1 className="text-sub flex items-center">
              Change your password at anytime.
            </h1>
          </div>
        </div>
        <div className="text-sub flex h-full w-auto items-center pr-[15px] text-2xl">
          <GoChevronRight />
        </div>
      </button>
      <button
        type="button"
        className={
          'hover-main flex h-[80px] w-full cursor-pointer items-center justify-between'
        }
        onClick={() => {
          navigate('../deactivate')
        }}
      >
        <div className="flex items-center justify-between">
          <IoHeartOutline className="text-sub mr-[30px] ml-[30px] text-lg" />
          <div className="flex w-auto flex-col text-wrap">
            <h1 className="flex items-center">Deactivate your account</h1>
            <h1 className="text-sub flex items-center">
              Find out how you can deactivate your account.
            </h1>
          </div>
        </div>
        <div className="text-sub flex h-full w-auto items-center pr-[15px] text-2xl">
          <GoChevronRight />
        </div>
      </button>
    </div>
  )
}

export default Account
